import React, {useEffect} from 'react'
import ModalEmitir from '../../../../../components/Modals/ModalsFacturacion/ModalEmitir'
import ModalResumenFacturaEmitida from './SEModalResumenFacturaEmitida'
import ModalImprimirFactura from '../../../../../components/Modals/ModalsFacturacion/ModalImprimirFactura'
import ModalEnviarEmail from '../../../../../components/Modals/ModalsFacturacion/ModalEnviarEmail'
import {State} from '../../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
  actionSujetoExcluidoEmision,
  actionsOperaciones,
} from '../../../../../actions/action-creators'
import {OPSendEmail} from '../../../../../interfaces/operaciones.interface'
import {emailInvoice} from '../../../../../utils/invoice/validateSendInvoice'
import {generalOpenModalMessage} from '../../../../../actions/general.actions'
import {useHistory} from 'react-router'
import {anularFactura} from '../../../../../actions/operaciones/operaciones.actions'
import ModalAnularFactura2 from '../../../../../components/Modals/ModalsFacturacion/ModalAnularFactura2'
import { sujetoExcluidoClearAll } from '../../../../../actions/sujeto-excluido/sujetoExcluidoEmision.actions'
import { convertDateFormatAnular } from '../../../../../utils/stringDate'
import { docsDatosReceptorReset } from '../../../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../../../actions/forma-pago.actions'
import { unirChipsArray, unirChipsReturnFirst } from '../../../../../utils/strings.utils'

const SEModalsResumenControl = () => {
  const {modals, datosFacturaRes, datosEmisor, formCliente, formSucursal, calculosArrayProductos, anulado, } = useSelector((state: State) => state.sujetoExcluido)
  const {resultAnulaciones} = useSelector((state: State) => state.historial)
  const loader = useSelector((state: State) => state.general.loader)
  const idDoc = useSelector((state: State) => state.documentos.activeDoc?.idDoc)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionSujetoExcluidoEmision, dispatch)
  const {sendTransactionEmail} = bindActionCreators(actionsOperaciones, dispatch)
  const history = useHistory()

  useEffect(() => {
    if (resultAnulaciones.length > 0) actionsFE.sujetoExcluidoVerificarAnulacion(funcionRedirigir)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultAnulaciones])
  
  const funcionRedirigir = () => {
    dispatch(sujetoExcluidoClearAll())
    dispatch(docsDatosReceptorReset())
    dispatch(handleRestartStateFormaPago())
    history.push('/otros-documentos/sujeto-excluido/formulario')
  }

  const handleEnviarEmail = async (formEnvio: emailInvoice) => {
    if (loader) return
    const sendEmail: OPSendEmail = {
      Correo: formEnvio.email.trim(),
      Documento: datosFacturaRes?.JsonFactura,
      Sello: datosFacturaRes?.Sello,
      json: datosFacturaRes?.JsonFacturaFile || "",
    }

    if (await sendTransactionEmail(sendEmail)) {
      dispatch(generalOpenModalMessage(`Enviar por email`, `El correo fue enviado exitosamente.`))
      actionsFE.sujetoExcluidoOpenCloseModalEmail(false)
    }
  }

  const handleClicEmitir = () => actionsFE.sujetoExcluidoClicEmitirModal(history)

  const handleAnular = async () => {
    if (anulado) return
    const anularDoc: any = {
      documento: datosFacturaRes.JsonFactura,
      sellorecibido: datosFacturaRes.Sello,
      DetallesDTE: {
        receptor: getReceptor(),
        emisor: getEmisor(),
        resumen: {
          totalIva: calculosArrayProductos.totalImpuesto1,
        },
        identificacion: {
          tipoDte: idDoc,
          codigoGeneracion: datosFacturaRes.codigoGeneracion,
          numeroControl: `DTE-${idDoc}-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`,
          fecEmi: convertDateFormatAnular(datosFacturaRes.fhProcesamiento.split(' ')[0]),
        },
      },
    }
    dispatch(anularFactura([anularDoc]))
  }

  const getReceptor = () => {
    return {
      numDocumento: formCliente.numId ? formCliente.tipoDocumento === "13" ? formCliente.numId : formCliente.numId?.trim().replace(/-/g, '') : null,
      tipoDocumento: formCliente.tipoDocumento ? formCliente.tipoDocumento === "sinDocumento" ? null : formCliente.tipoDocumento : null,
      nrc: null,
      nombre: formCliente.nombre ? formCliente.nombre?.trim() : null,
      telefono: formCliente.telefono ? formCliente.telefono?.trim() : null,
      correo: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!) ?? null,
    }
  }
  const getEmisor = () => {
    return {
      nombre: datosEmisor.nombre,
      nit: datosEmisor.nit,
      nrc: datosEmisor.nrc,
      telefono: datosEmisor.telefono,
      correo: datosEmisor.correo,
      tipoEstablecimiento: datosEmisor.tipoestablecimiento,
    }
  }

  return (
    <>
      {modals.activeEmitirFactura && (
        <ModalEmitir Styles={{width:"70%", maxWidth: "450px"}} title="Emitir factura de sujeto excluido" detail="Estás a punto de emitir esta factura de sujeto excluido ¿deseas continuar?"
          ClicCancelar={actionsFE.sujetoExcluidoCloseModalEmitir}
          ClicEmitir={handleClicEmitir}
        />
      )}
      {modals.activeFacturaEmitida && <ModalResumenFacturaEmitida />}
      {modals.activeImpresion && (
        <ModalImprimirFactura
          documento={datosFacturaRes?.JsonFactura}
          sello={datosFacturaRes?.Sello}
          onCancel={() => actionsFE.sujetoExcluidoOpenCloseModalImprimir(false)}
          onPrint={() => actionsFE.sujetoExcluidoOpenCloseModalImprimir(false)}
        />
      )}
      {modals.activeEmail && (
        <ModalEnviarEmail
          defaultEmail={''} 
          chipsEmail={unirChipsArray(formCliente.chipsEmail!, formCliente.email!)}
          showBackBtn={true}
          onBackBtn={() => actionsFE.sujetoExcluidoOpenCloseModalEmail(false)}
          onSendEmail={handleEnviarEmail}
        />
      )}
      {modals.activeAnular && (
        <ModalAnularFactura2
          closeModalEliminar={() => actionsFE.sujetoExcluidoOpenCloseModalAnular(false)}
          actionEliminar={handleAnular}
          detail={`DTE-${idDoc}-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`}
        />
      )}
    </>
  )
}

export default SEModalsResumenControl
